import classNames from "./OverflowPopover.module.css";
import { IoEllipsisHorizontal } from "react-icons/io5";
import SettingsDialog from "../../common/dialogs/SettingsDialog";
import { useLocalParticipant } from "@livekit/components-react";
import { useMemo, useState } from "react";
import { LocalAudioTrack } from "livekit-client";
import Button from "../../common/Button";
import Popover from "../../common/Popover";
import VoiceOptionsDialog from "../../common/dialogs/voice/VoiceOptionsDialog";
import useUser from "../../../hooks/user";
import { Organization } from "../../../hooks/api";

export default function OverflowPopover(props: {
  organization: Organization;
  type: "speaker" | "attendee";
}) {
  const { microphoneTrack: microphoneTrackPublication } = useLocalParticipant();
  const localAudioTrack = useMemo(() => {
    return microphoneTrackPublication?.audioTrack as
      | LocalAudioTrack
      | undefined;
  }, [microphoneTrackPublication]);

  const [open, setOpen] = useState(false);
  const [user] = useUser();

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      trigger={
        <Button
          color={open ? "white" : "gray"}
          borderColor={open ? "primary" : "dark-gray"}
          backgroundColor="black"
        >
          <IoEllipsisHorizontal />
        </Button>
      }
      content={
        <div className={classNames.Content}>
          {props.type === "speaker" && (
            <SettingsDialog
              trigger={<button>Audio</button>}
              localAudioTrack={localAudioTrack}
              initialSelectedSetting="audio"
            />
          )}
          <SettingsDialog
            trigger={<button>Text customization</button>}
            localAudioTrack={localAudioTrack}
            initialSelectedSetting="text-customization"
          />
          <SettingsDialog
            trigger={<button>Text speed</button>}
            localAudioTrack={localAudioTrack}
            initialSelectedSetting="text-speed"
          />
          {props.type === "attendee" && (
            <SettingsDialog
              trigger={<button>Text translation</button>}
              localAudioTrack={localAudioTrack}
              initialSelectedSetting="text-translation"
            />
          )}
          {props.organization.voice_translation_enabled &&
            props.type === "speaker" && (
              <VoiceOptionsDialog
                trigger={<button>Voice avatar</button>}
                locale={user.metadata.selectedLanguage}
                basic={!props.organization.voice_avatar_enabled}
              />
            )}
        </div>
      }
      align="end"
    />
  );
}
